import React, { useState, useEffect } from 'react';
import { Button, Input, message, Select, Space, Spin, Table, Typography } from 'antd';
import { API_METHODS, ANTD_TEXT, ERROR_MSG, CCI_GPT_SERVICE_URLs } from '../../Helper/Constant';
import { cciGpt, cciGptService, researchUI } from '../../../api';
const { Text, Link } = Typography;

const SearchType = {
    text: {
        label: 'Search Text',
        value: 'text',
    },
    url: { label: 'Search URL', value: 'url' },
};
export const CciGptSearch = (props) => {
    const searchTypeOptions = [
        {
            label: SearchType.text.label,
            value: SearchType.text.value,
        },
        {
            label: SearchType.url.label,
            value: SearchType.url.value,
        },
    ];

    const [selSearchType, setSelSearchType] = useState(searchTypeOptions[0].value);
    const [searchText, setSearchText] = useState('');
    const [responseData, setResponseData] = useState([]);
    const [loading, setLoading] = useState(false);

    const onSearchTypeChange = (value) => {
        setSearchText('');
        setSelSearchType(value);
    };

    const searchType = <Select defaultValue="text" className="select-before" options={searchTypeOptions} onChange={onSearchTypeChange} />;

    const searchTextUrl = async () => {
        setLoading(true);
        let uri = CCI_GPT_SERVICE_URLs.SEARCH_URL;
        const data = {
            app_id: props.appId.map(String),
        };
        if (selSearchType === SearchType.text.value) {
            data[SearchType.text.value] = searchText;
            uri = CCI_GPT_SERVICE_URLs.SEARCH_TEXT;
        }
        if (selSearchType === SearchType.url.value) {
            data[SearchType.url.value] = searchText;
            uri = CCI_GPT_SERVICE_URLs.SEARCH_URL;
        }
        const result = await cciGptService({
            method: API_METHODS.POST,
            uri,
            data,
        });
        if (result.success === 1) {
            if (result.data.status_code === 200) {
                setResponseData(result.data.data);
            } else {
                message.error(ERROR_MSG.GENERAL_ERROR);
            }
        } else {
            message.error(ERROR_MSG.GENERAL_ERROR);
        }
        setLoading(false);
    };

    const onClickSearch = () => {
        if (searchText.length > 2) {
            searchTextUrl();
        } else {
            message.info('Please Type atleast 3 character.');
        }
    };

    const onInputChange = (e) => {
        setSearchText(e.target.value);
    };

    return (
        <>
            <Space direction="horizontal">
                <Input className="ns-width-full" addonBefore={searchType} value={searchText} onChange={onInputChange} />
                <Button onClick={onClickSearch}>Search</Button>
                {selSearchType === SearchType.url.value ? <SearchUrlView data={responseData} loading={loading} /> : ''}
            </Space>
            {selSearchType === SearchType.text.value ? (
                <SearchTextView key={'search_view'} data={responseData} searched={true} loading={loading} />
            ) : (
                ''
            )}
        </>
    );
};

const SearchUrlView = (props) => {
    const [urlPresent, setUrlPresent] = useState(false);
    useEffect(() => {
        if (props?.data === true) {
            setUrlPresent(true);
        } else {
            setUrlPresent(false);
        }
    }, [props]);
    return (
        <>
            {props.loading ? <Spin></Spin> : ''}
            {urlPresent ? <Text type="success">Url Present</Text> : ''}
        </>
    );
};

const SearchTextView = (props) => {
    const columns = [
        {
            title: 'Text',
            dataIndex: 'text',
            key: 'text',
            render: (text) => <Text type={ANTD_TEXT.TYPE_SECONDARY}>{text}</Text>,
        },
        {
            title: 'URL',
            dataIndex: 'url',
            key: 'url',
            width: '30%',
            render: (url) => (
                <a target={'_blank'} href={url}>
                    {url}
                </a>
            ),
        },
    ];
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        if (props.data && props.data instanceof Array) {
            let tableRowData = [];
            props.data.map((row) => {
                tableRowData.push({ text: row[0], url: row[1] });
            });
            setTableData(tableRowData);
        }
    }, [props]);
    return (
        <Table
            className="ns-margin-top-small"
            loading={props.loading}
            size={'small'}
            scroll={{ y: 300 }}
            dataSource={tableData}
            columns={columns}
            tableLayout={'fixed'}
            bordered
        />
    );
};
